import { Component, OnInit } from '@angular/core';
import { ServiciosService } from 'app/services/servicios.service';
import * as moment from 'moment';
import { MatDialog} from '@angular/material/dialog';
import { EstadisticasComponent } from 'app/modals/estadisticas/estadisticas.component';
import { MovilDespachoComponent } from 'app/modals/movil-despacho/movil-despacho.component';

@Component({
  selector: 'app-tag-estadisticas-despacho',
  templateUrl: './tag-estadisticas-despacho.component.html',
  styleUrls: ['./tag-estadisticas-despacho.component.scss']
})
export class TagEstadisticasDespachoComponent implements OnInit {

  public codigosAmarillos;
  public codigosAmarillos2;
  public codigosRojos;
  public codigosRojos2;
  public codigosVerdes;
  public codigosVerdes2;
  public totalServicios;
  public totalServicios2;
  public serviciosCancelados;
  public serviciosCancelados2;
  public traslado;
  public traslado2;
  public sinDespacho;
  public sinDespacho2;
  public enProceso;
  public enProceso2;
  public pasadasdetiempo;
  public pasadasdetiempo2;
  public equivocadas;
  public equivocadas2;
  public manuales;
  public manuales2;
  public conlaApp;
  public conlaApp2;
  public trasladoprogramado;
  public trasladoprogramado2;
  public consultasactivas;
  public consultasactivas2;
  public enDesplasamiento;
  public enDesplasamiento2;
  public contrasladoActivo;
  public contrasladoActivo2;
  public activasSinTerminar;
  public activasSinTerminar2;
  public masde100;
  public masde100_2;
  public codigosAmarillosActivos;
  public codigosAmarillos2Activos;
  public codigosRojosActivos;
  public codigosRojos2Activos;
  public codigosVerdesActivos;
  public codigosVerdes2Activos;
  public turnosActivos;
  public turnosActivos2;
  public en520;
  public en520_2;

  public today;

  constructor(private servicios: ServiciosService, private dialog: MatDialog) { }

  ngOnInit() {
    this.newEstadisticas();
    this.en520_2 =0;
  }

  reloadEstadisticas(){
    this.newEstadisticas();
  }

  newEstadisticas(){
    let now = moment();
    let esp = now.locale('es');
    this.today = now.format('dddd, D MMMM YYYY')

    this.servicios.codigosAmarillos().subscribe((data)=>{
      this.codigosAmarillos = Object.keys(data).length;
      this.codigosAmarillos2 = data;
    })

    this.servicios.codigosRojos().subscribe((data) => {
      this.codigosRojos = Object.keys(data).length;
      this.codigosRojos2 = data;
    })

    this.servicios.codigosVerdes().subscribe((data) => {
      this.codigosVerdes = Object.keys(data).length;
      this.codigosVerdes2 = data;
    })

    this.servicios.codigosAmarillosActivos().subscribe((data)=>{
        this.codigosAmarillosActivos = Object.keys(data).length;
        this.codigosAmarillos2Activos = data;
    })

    this.servicios.codigosRojosActivos().subscribe((data) => {
        this.codigosRojosActivos = Object.keys(data).length;
        this.codigosRojos2Activos = data;
    })

    this.servicios.codigosVerdesActivos().subscribe((data) => {
        this.codigosVerdesActivos = Object.keys(data).length;
        this.codigosVerdes2Activos = data;
    })

    this.servicios.totalServiciosDia().subscribe((data) => {
      this.totalServicios = Object.keys(data).length;
      this.totalServicios2 = data;
    })

    this.servicios.servicioscancelados().subscribe((data) => {
        this.serviciosCancelados = Object.keys(data).length;
        this.serviciosCancelados2 = data;
    })

    this.servicios.servicioscontraslado().subscribe((data) => {
      this.traslado = Object.keys(data).length;
      this.traslado2 = data;
    })

    this.servicios.sinDespacho().subscribe((data) => {
      this.sinDespacho = Object.keys(data).length;
      this.sinDespacho2 = data;
    })

    this.servicios.enProceso().subscribe((data) => {
      this.enProceso = Object.keys(data).length;
      this.enProceso2 = data;
    })

    this.servicios.pasadasDetiempo().subscribe((data) => {
      this.pasadasdetiempo = Object.keys(data).length;
      this.pasadasdetiempo2 = data;
    })

    this.servicios.equivocadas().subscribe((data) => {
      this.equivocadas = Object.keys(data).length;
      this.equivocadas2 = data;
    })

    this.servicios.manuales().subscribe((data) => {
      this.manuales = Object.keys(data).length;
      this.manuales2 = data;
    })

    this.servicios.conlaApp().subscribe((data) => {
      this.conlaApp = Object.keys(data).length;
      this.conlaApp2 = data;
    })

    this.servicios.trasladoprogramado().subscribe((data) => {
      this.trasladoprogramado = Object.keys(data).length;
      this.trasladoprogramado2 = data;
    })

    this.servicios.activos().subscribe((data) => {
      this.consultasactivas = Object.keys(data).length;
      this.consultasactivas2 = data;
    })

    this.servicios.enDespalsamiento().subscribe((data) => {
      this.enDesplasamiento = Object.keys(data).length;
      this.enDesplasamiento2 = data;
    })

    this.servicios.conTrasladoActivo().subscribe((data) => {
        this.contrasladoActivo = Object.keys(data).length;
        this.contrasladoActivo2 = data;
    })

    this.servicios.activasSinTerminar().subscribe((data) => {
        this.activasSinTerminar = Object.keys(data).length;
        this.activasSinTerminar2 = data;
    })

    this.servicios.masde100().subscribe((data)=>{
        this.masde100 =  Object.keys(data).length;
        this.masde100_2 = data;
    })

    this.servicios.turnosActivos().subscribe((data)=>{
        this.turnosActivos = Object.keys(data).length;
        this.turnosActivos2 = data;
    })

    this.servicios.en520().subscribe((data)=>{
        this.en520 = Object.keys(data).length;
        this.en520_2 = data;
    })
  }

  estadisticas(param){
    switch (param) {
      case 1:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Servicios del Dia',
            servicios: this.totalServicios2,
            width:'100%'
          }
        })
        break;
      case 2:
        this.dialog.open(EstadisticasComponent, {
          data:{
            title:'Consultas Activas',
            servicios: this.consultasactivas2
          }
        })
        break;
      case 3:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas En Proceso',
            servicios: this.enProceso2
          }
        })
        break;
      case 4:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas En Despalsamiento',
            servicios: this.enDesplasamiento2
          }
        })
        break;
      case 5:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas Sin Despacho',
            servicios: this.sinDespacho2
          }
        })
        break;
      case 6:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas En Traslado',
            servicios: this.traslado2
          }
        })
        break;
      case 7:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas Con Traslado Programado',
            servicios: this.trasladoprogramado2
          }
        })
        break;
      case 8:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas Canceladas',
            servicios: this.serviciosCancelados2
          }
        })
        break;
      case 9:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas De Mas De 4 Horas',
            servicios: this.pasadasdetiempo2
          }
        })
        break;
      case 10:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Mas De 100%',
            servicios: this.masde100_2
          }
        })
        break;
      case 11:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas Manuales',
            servicios: this.manuales2,
            tipo:'manual'
          }
        })
        break;
      case 12:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas Con La Aplicacion',
            servicios: this.conlaApp2
          }
        })
        break;
      case 13:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas Equivocadas',
            servicios: this.equivocadas2
          }
        })
        break;
      case 14:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas Con Codigo Verde',
            servicios: this.codigosVerdes2
          }
        })
        break;
      case 15:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas Con Codigo Amarillo',
            servicios: this.codigosAmarillos2
          }
        })
        break;
      case 16:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Consultas Con Codigo Rojo',
            servicios: this.codigosRojos2
          }
        })
        break;
      case 17:
        this.dialog.open(EstadisticasComponent, {
          data: {
            title:'Con translado Activo',
            servicios: this.contrasladoActivo2
          }
        })
        break;
      case 18:
        this.dialog.open(EstadisticasComponent, {
            data: {
              title:'Consultas Activas Sin Terminar',
              servicios: this.activasSinTerminar2
            }
          })
        break;
        case 19:
            this.dialog.open(EstadisticasComponent, {
                data: {
                    title:'Consultas Con Codigo Verde Activo',
                    servicios: this.codigosVerdes2Activos
                }
            })
        break;
        case 20:
            this.dialog.open(EstadisticasComponent, {
                data: {
                    title:'Consultas Con Codigo Amarillo Activo',
                    servicios: this.codigosAmarillos2Activos
                }
            })
        break;
        case 21:
            this.dialog.open(EstadisticasComponent, {
                data: {
                title:'Consultas Con Codigo Rojo Activo',
                servicios: this.codigosRojos2Activos
                }
            })
        break;
        case 22:
            this.dialog.open(MovilDespachoComponent, {
                data: {
                title:'En 520',
                servicios:this.en520_2
                }
            })
        break;
        case 23:
            this.dialog.open(MovilDespachoComponent, {
                data: {
                title:'Turnos Activos',
                servicios: this.turnosActivos2
                }
            })
        break;
    }
  }

}